<template>
  <main
    class="main internet_product_list"
    role="main"
    ref="main"
    v-show="isCompleted"
  >
    <div class="int_pro_list_con">
      <div class="int_pro_list_top">
        <div class="list_txt_1">
          <img
            :src="require(`@/assets/front/images/v2/logos/${getLogoImg()}.svg`)"
            class="logo"
          />
        </div>
        <div class="list_txt_2">
          <span>{{ getTelecomName() }}</span
          >에서 내 또래들은<br />
          이런 상품을 선택했어요!
        </div>
      </div>
      <div class="int_pro_list">
        <ul class="int_pro_list_ul">
          <InternetProduct
            v-for="(item, index) in internetProductList"
            :key="index"
            :item="item"
            :isProductPage="true"
            :isNum="index + 1"
            @view="goInternetView"
          />
        </ul>
      </div>
    </div>
  </main>
</template>
<script>
import * as util from '@common/lib/common/utils.js';

import format from 'date-fns/format';

import Lottie from 'vue-lottie/src/lottie';
import * as animationData from '@/assets/front/animation/ani_home_internet.json';

import InternetProduct from '@/front/customer/views/home/components/InternetProduct';

import {
  mapActions as internetMapActions,
  mapGetters as internetMapGetters,
} from '@common/store/modules/internet';
import * as internetTypes from '@common/store/modules/internet/types';

import {
  mapActions as userMapActions,
  mapGetters as userMapGetters,
} from '@common/store/modules/user';
import * as userTypes from '@common/store/modules/user/types';

import {
  mapActions as productMapActions,
  mapGetters as productMapGetters,
} from '@common/store/modules/product';
import * as productTypes from '@common/store/modules/product/types';

import InternetFilter from '@/common/components/modal/InternetFilter';

export default {
  name: 'internet_product_list',
  components: {
    InternetProduct,
  },

  data() {
    return {
      isCompleted: false,

      telecomId: '',
      productType: '',

      internetProductList: [],
      internetProductTotal: 0,

      telecomLogoImg: [
        { id: 'SKT', img: 'logo_skt_round', name: 'SKT' },
        { id: 'KT', img: 'logo_kt_round', name: 'KT' },
        { id: 'LGUPLUS', img: 'logo_lgu_round', name: 'LGU+' },
      ],
    };
  },
  async created() {
    this.telecomId = this.$route.query.telecomId;
    this.productType = this.$route.query.productType;

    await this.getInternetProducts(this.telecomId, this.productType);

    this.isCompleted = true;
  },
  async mounted() {},
  computed: {
    ...internetMapGetters({
      internetCommerceIngList: internetTypes.INTERNET_COMMERCE_ING_LIST,
      internetCommerceEndList: internetTypes.INTERNET_COMMERCE_END_LIST,
      internetCommercUserQuotationNewList:
        internetTypes.INTERNET_COMMERCE_USER_QUOTATION_NEW,
    }),
  },
  methods: {
    ...userMapActions([userTypes.FETCH_ME]),
    ...internetMapActions([
      internetTypes.SELECT_INTERNET_COMMERCE_ESTIMATION,
      internetTypes.SELECT_INTERNET_COMMERCE_USER_QUOTATION_NEW,
      internetTypes.SELECT_INTERNET_PRODUCTS,
      internetTypes.UPDATE_INTERNET_VIEW_PRODUCT,
    ]),
    ...productMapActions([productTypes.FETCH_INTERNET_BEST_PRODUCTS]),
    goLink(link) {
      this.$router.push({ name: link });
    },
    async getInternetProducts(telecomId, productType) {
      const params = {
        telecomId,
        productType,
      };
      //this.internetProductList
      const productList = await this[productTypes.FETCH_INTERNET_BEST_PRODUCTS](
        params,
      );

      console.log(productList);
      this.internetProductList = productList.content;
    },
    async getInternetCommerceIngList() {
      await this[internetTypes.SELECT_INTERNET_COMMERCE_ESTIMATION]({
        page: 1,
        size: 10,
        status: 'ING',
        orderType: 'CREATED_AT_DESC',
      });
    },
    async getInternetCommerceEndList() {
      await this[internetTypes.SELECT_INTERNET_COMMERCE_ESTIMATION]({
        page: 1,
        size: 10,
        status: 'END',
        orderType: 'CREATED_AT_DESC',
      });
    },

    goInternetView(item) {
      // 상품 조회 카운트 증가
      this.upInternetViewProductCnt(item);

      // this.setVisitPage();
      localStorage.setItem('internetProductSelect', JSON.stringify(item));
      this.$router.push({
        name: 'InternetCommerce.ItemView',
      });
    },
    upInternetViewProductCnt(item) {
      const params = {
        telecomId: item.telecomId,
        internetId: item.internetId,
        settopId: item.settopId,
        tvId: item.tvId,
        wifiId: item.wifiId,
      };
      console.log('params');
      console.log(params);
      this[internetTypes.UPDATE_INTERNET_VIEW_PRODUCT](params);
    },
    getLogoImg() {
      const findTelecom = this.telecomLogoImg.findIndex(
        element => element.id == this.telecomId,
      );
      return this.telecomLogoImg[findTelecom].img;
    },
    getTelecomName() {
      const findTelecom = this.telecomLogoImg.findIndex(
        element => element.id == this.telecomId,
      );
      return this.telecomLogoImg[findTelecom].name;
    },
  },
};
</script>
